<template>
  <transition name="Promo">
    <div class="Promo">
      <div class="Promo__slide">
        <div class="Promo__close" @click="$parent.showPromo = false">
          <img :src="require('@/components/tutorial/img/close.png')" />
        </div>

        <div class="Promo__off" v-if="shared == 2">
          <img :src="require('@/components/cards/img/off_' + lang  + '.png')" />
        </div>

        <div class="Promo__title">{{ trans('title') }}</div>
        <div class="Promo__description">{{ trans('description_' + shared) }}</div>

        <div class="Promo__btns">
          <div @click="redeem" v-if="shared == 2" class="Promo__btn Btn is-border-black">{{ trans('btn_redeem') }}</div>
          <div @click="backToMap" class="Promo__btn-small">{{ trans('btn_' + shared) }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Promo',
  computed: {
    shared() { return this.$store.getters['user/shared'] },
  },
  translations: {
    en: {
      title: 'Thanks for sharing!',
      description_1: "Share an additional photo to get 15% off merchandise today.",
      description_2: "You’ve unlocked your 15% discount at the merchandise store! Valid one time only; not valid for food and beverages.",
      btn_redeem: 'Redeem your coupon',
			btn_1: "Back to the map",
      btn_2: 'Save coupon and go back to the map',
    },
    fr: {
      title: 'Merci d’avoir partagé!',
			description_1: "Partagez une deuxième photo pour obtenir 15% de rabais sur la marchandise aujourd'hui.",
      description_2: "Vous obtenez un rabais de 15 % sur vos achats en boutique aujourd'hui. Valide une fois et non valide pour les aliments et les boissons.",
      btn_redeem: 'Obtenez votre coupon',
			btn_1: "Revenir à la carte",
      btn_2: 'Sauvegarder le coupon et revenir à la carte',
    },
  },
	methods: {
    backToMap() {
      this.$parent.showPromo = false
      this.$router.push({ name: 'map.' + this.lang })
    },
    redeem() {
      this.$parent.showPromo = false
      this.$router.push({ name: 'map.' + this.lang })
    }
	}

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Promo
  position fixed
  top 0px
  left 0px
  right 0px
  bottom 0px
  background rgba(#232529, .9)
  z-index 999999999
  transition opacity 1s, transform 1s
  text-align center
  &-enter
  &-leave-active
    opacity 0
    transform scale(.9)

  &__title
    color black
    font-size 20px
    font-weight 700
    line-height 25px
    padding 0 20px

  &__description
    color #A09C94
    font-size 14px
    margin 10px 0
    line-height 20px
    letter-spacing .19px
    padding 0 20px

  &__btns
    margin 0 20px

  &__btn-small
    color #A09C94
    font-size 13px
    padding 20px 20px 40px
    line-height 20px
    text-decoration none
    display block

  &__off
    width 140px
    margin 0px auto 20px

  &__slide
    border-radius 10px
    background 5px
    position absolute
    width 300px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    background white
    padding-top 60px

  &__close
    position absolute
    right 20px
    top 20px

</style>
